import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 20px;

  @media only screen and (max-width: 768px) {
    padding: 10px;
  }
`;

const Title = styled.h1`
  font-size: 28px;

  @media only screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

export default function Chinese2() {
  return (
    <Wrapper>
      <Title>📐 second</Title>
      <p>Abu Reyalin</p>
    </Wrapper>
  );
}
